module.exports = __webpack_public_path__ + "img/rank_sergeant.0a25f2fc.svg";